module.exports = __webpack_public_path__ + "img/new-logo.45d2381d.png";